<template>
    <div class="calculator">
        <div v-if="grouped_components.length">
            <b-row class="mt-1">
                <b-col>
                    <b-alert show
                             variant="info"
                             dismissible
                             class="mb-2"
                    >
                        <div class="d-flex align-items-start">
                            <i class="fa fa-info-circle mr-2 mt-1"></i>
                            <div>
                                <strong>Información importante</strong>
                                <ol class="pl-3 mt-2 mb-0">
                                    <li>Si sabe que un componente no presenta toxicidad aguda (ejemplo: agua) y es relevante
                                        considerar
                                        su porcentaje, marque la casilla en la columna correspondiente.
                                    </li>
                                    <li>Marcar estas casillas es necesario para que el sistema calcule correctamente los
                                        porcentajes totales.
                                    </li>
                                </ol>
                            </div>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa fa-warning mr-2 mt-2"/>
                            <div>
                                <p class="font-weight-bold mt-1 mb-0">
                                    Solo seleccione esta opción para sustancias que con certeza no
                                    representan peligro en las vías de exposición indicadas.
                                </p>
                            </div>
                        </div>
                    </b-alert>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="4"
                       class="my-3"
                >
                    <el-input id="name"
                              name="name"
                              v-model="name"
                              size="small"
                              type="text"
                              placeholder="Filtro por componente"
                    />
                    <i v-if="!!name.length"
                       @click="name = ''"
                       title="Cancelar, y restablecer datos."
                       class="fa fa-close filter-search-form-calc-icon-cancel cursor-pointer"
                    />
                </b-col>
                <b-col md="4"
                       class="my-3"
                >
                    <b-btn variant="info"
                           class="mx-1"
                           size="sm"
                           @click="downloadClassificationAcuteToxicity"
                           v-if="mode === 2"
                    >
                        <i class="fa fa-file-pdf-o"/>
                        Descargar pdf
                    </b-btn>
                </b-col>
                <b-col md="4"
                       class="my-3"
                >
                    <b-button-group class="float-right mr-1"
                                    size="sm"
                    >
                        <b-button @click="mode = 1"
                                  :variant="mode === 1 ? 'secondary' : 'light'"
                        >
                            <i class="fa fa-list"/>
                        </b-button>
                        <b-button @click="mode = 2"
                                  :variant="mode === 2 ? 'secondary' : 'light'"
                        >
                            <i class="fa fa-table"/>
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>

            <form_mode v-if="mode === 1"
                       :name.sync="name"
                       @getClassifications="getClassifications()"
            />

            <summation_method v-else
                              :name.sync="name"
                              @getClassifications="getClassifications()"
            />

            <div class="p-2 mb-2">
                <b-row>
                    <b-col md="4"
                           class="mb-0"
                    >
                        <div class="metric-card p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div class="metric-icon bg-soft-success">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="32"
                                         height="32"
                                         viewBox="0 0 64 64"
                                         class="icon-success"
                                    >
                                        <path fill="currentColor"
                                              d="M34.478.972c-10.741 0-20.641 8.064-22.703 16.95c-.459 1.973-.975 7.135-.975 7.135l-4.935 12.45a1.91 1.91 0 0 0 1.758 2.649h.524a1.24 1.24 0 0 1 .289-1.201a15.4 15.4 0 0 1 2.392-2.03a1.26 1.26 0 1 1 1.417 2.086c-.496.336-.977.744-1.445 1.18v4.631h1.113a1.26 1.26 0 1 1 0 2.522h-1.085c.295 4.889 4.342 8.766 9.309 8.766h3.703v7.252h5.543v-.945a1.262 1.262 0 1 1 2.522 0v.945h2.267v-.943a1.262 1.262 0 1 1 2.522 0v.943h12.411V43.265c5.506-4.331 9.046-11.065 9.046-18.617C58.15 11.573 47.558.973 34.478.973zM16.635 24.433a2.64 2.64 0 0 1 2.64 2.644a2.64 2.64 0 0 1-2.64 2.642a2.643 2.643 0 1 1 0-5.286m-2.904 12.283a1.26 1.26 0 0 1 .863-1.56a14.7 14.7 0 0 1 3.102-.532a1.25 1.25 0 0 1 1.342 1.175a1.26 1.26 0 0 1-1.174 1.343a12 12 0 0 0-2.57.44a1.266 1.266 0 0 1-1.562-.866zm4.849 10.627h-2.884a1.26 1.26 0 0 1 0-2.522h2.884a1.26 1.26 0 0 1 0 2.522m16.455-17.392h2.884a1.26 1.26 0 0 1 0 2.522h-2.884a1.26 1.26 0 0 1 0-2.522m-6.831 3.324c.578-1.038 1.471-1.892 2.584-2.463a1.262 1.262 0 0 1 1.156 2.241c-.668.346-1.199.846-1.536 1.45a1.26 1.26 0 0 1-1.715.49a1.264 1.264 0 0 1-.489-1.718m-7.903 2.589a1.26 1.26 0 0 1 1.45-1.042a17.6 17.6 0 0 1 3.002.768a1.26 1.26 0 0 1 .772 1.607a1.26 1.26 0 0 1-1.607.773a15.6 15.6 0 0 0-2.575-.658a1.26 1.26 0 0 1-1.042-1.448m5.85 12.029a1.265 1.265 0 0 1-1.711.507a8.6 8.6 0 0 0-2.351-.857a1.261 1.261 0 1 1 .513-2.47c1.076.225 2.101.598 3.041 1.109c.613.334.839 1.1.507 1.71zm.517-10.142c.246-.386.669-.572 1.096-.563c.127-.401.433-.74.871-.852a1.26 1.26 0 0 1 1.534.911c.315 1.234.956 2.297.962 2.308a1.261 1.261 0 0 1-1.963 1.556a15.5 15.5 0 0 0-2.114-1.618a1.26 1.26 0 0 1-.386-1.741zm1.629 14.908a9.8 9.8 0 0 0-1.339-2.166a1.26 1.26 0 0 1 .175-1.775a1.26 1.26 0 0 1 1.775.175a12.3 12.3 0 0 1 1.684 2.72a1.258 1.258 0 0 1-1.145 1.784a1.27 1.27 0 0 1-1.15-.739zm3.608 5.973a1.26 1.26 0 1 1-2.522 0v-.705c0-.675-.048-1.343-.14-1.988a1.265 1.265 0 0 1 1.068-1.431a1.255 1.255 0 0 1 1.428 1.07c.112.763.166 1.553.166 2.349zm.874-12.583a15.3 15.3 0 0 0-1.316-2.312a1.262 1.262 0 0 1 2.075-1.435c.587.85 1.104 1.756 1.534 2.694a1.261 1.261 0 0 1-2.293 1.054zm1.387 5.955a15.3 15.3 0 0 0-.302-2.642a1.261 1.261 0 1 1 2.472-.502c.205 1.009.324 2.045.352 3.076a1.26 1.26 0 0 1-1.224 1.294q-.018.003-.037.002c-.679 0-1.24-.544-1.26-1.227zm2.528 6.631a1.26 1.26 0 1 1-2.522 0v-2.881a1.262 1.262 0 1 1 2.522 0zm.692-20.418v-2.149l.416-.004a4.893 4.893 0 0 0 4.877-4.866a4.893 4.893 0 0 0-4.877-4.866l-.416-.002v-2.146h.419c3.874 0 7.025 3.145 7.025 7.015s-3.151 7.019-7.025 7.019h-.419z"
                                        />
                                    </svg>
                                </div>
                                <div class="status-badge text-uppercase">ORAL (DL50)</div>
                            </div>
                            <h3 class="mb-1">
                                ETA: {{ Math.round((totals.dl_50_oral_total + Number.EPSILON) * 10000) / 10000 }}
                                <span class="small text-muted">mg/kg</span>
                            </h3>
                            <div v-if="mode === 2"
                                 class="d-flex justify-content-between align-items-end"
                            >
                                <div class="metric-detail">
                                    <div class="font-weight-bold small text-muted">Sumatoria:</div>
                                    <div class="text-muted">
                                        {{ Math.round((totals.dl_50_oral + Number.EPSILON) * 10000) / 10000 }}
                                    </div>
                                </div>
                                <div class="percentage-badge badge-danger">
                                    {{ Math.round((totals.dl_50_oral_percentage + Number.EPSILON) * 10000) / 10000 }} %
                                </div>
                            </div>
                        </div>
                    </b-col>

                    <b-col md="4"
                           class="mb-0"
                    >
                        <div class="metric-card p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div class="metric-icon bg-soft-success">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="32"
                                         height="32"
                                         viewBox="0 0 24 24"
                                         class="icon-success"
                                    >
                                        <path fill="currentColor"
                                              d="M19.75 5.33a1.25 1.25 0 0 0-1.25 1.25v4.59h-.83V4.08a1.25 1.25 0 0 0-2.5 0v7.09h-.84V3.25a1.25 1.25 0 1 0-2.5 0v7.92H11V5.33a1.25 1.25 0 0 0-2.5 0v9.93l-3.59-2a1 1 0 0 0-.5-.14a1 1 0 0 0-.66.25l-1.08 1L9.21 21a3.3 3.3 0 0 0 2.37 1h6.09A3.33 3.33 0 0 0 21 18.67V6.58a1.25 1.25 0 0 0-1.25-1.25M11 15a1 1 0 1 1 1-1a1 1 0 0 1-1 1m2 3a1 1 0 1 1 1-1a1 1 0 0 1-1 1m5-2a1 1 0 1 1 1-1a1 1 0 0 1-1 1m-1 3a1 1 0 1 1 1-1a1 1 0 0 1-1 1m-2-4a1 1 0 1 1 1-1a1 1 0 0 1-1 1"
                                        />
                                    </svg>
                                </div>
                                <div class="status-badge text-uppercase">CUTÁNEA (DL50)</div>
                            </div>
                            <h3 class="mb-1">
                                ETA: {{ Math.round((totals.dl_50_cutaneous_total + Number.EPSILON) * 10000) / 10000 }}
                                <span class="small text-muted">mg/kg</span>
                            </h3>
                            <div v-if="mode === 2"
                                 class="d-flex justify-content-between align-items-end"
                            >
                                <div class="metric-detail">
                                    <div class="font-weight-bold small text-muted">Sumatoria:</div>
                                    <div class="text-muted">
                                        {{ Math.round((totals.dl_50_cutaneous + Number.EPSILON) * 10000) / 10000 }}
                                    </div>
                                </div>
                                <div class="percentage-badge badge-warning">
                                    {{
                                        Math.round((totals.dl_50_cutaneous_percentage + Number.EPSILON) * 10000) / 10000
                                    }} %
                                </div>
                            </div>
                        </div>
                    </b-col>

                    <b-col md="4"
                           class="mb-0"
                    >
                        <div class="metric-card p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div class="metric-icon bg-soft-success">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="32"
                                         height="32"
                                         viewBox="0 0 24 24"
                                         class="icon-success"
                                    >
                                        <path fill="currentColor"
                                              d="M5 21q-1.275 0-2.137-.862T2 18v-4.175L4.625 6.8q.3-.825 1.05-1.312T7.3 5q.65 0 1.225.325t.95.875V9l-2.55 2.55L8 12.6l3-3V2h2v7.6l3 3l1.05-1.05L14.5 9V6.2q.375-.55.95-.875T16.675 5q.875 0 1.613.488T19.35 6.8l2.625 7.025V18q0 1.275-.875 2.138T18.975 21h-3q-1.25 0-2.112-.862T13 18v-2l.375-3.175l-1.375-1.4l-1.4 1.4L11 16v2q0 1.275-.875 2.138T8 21z"
                                        />
                                    </svg>
                                </div>
                                <div class="status-badge text-uppercase">INHALACIÓN (CL50)</div>
                            </div>
                            <h3 class="mb-1">
                                ETA: {{ Math.round((totals.cl_50_inhalation_total + Number.EPSILON) * 10000) / 10000 }}
                                <span class="small text-muted">mg/kg</span>
                            </h3>
                            <div v-if="mode === 2"
                                 class="d-flex justify-content-between align-items-end"
                            >
                                <div class="metric-detail">
                                    <div class="font-weight-bold small text-muted">Sumatoria:</div>
                                    <div class="text-muted">
                                        {{ Math.round((totals.cl_50_inhalation + Number.EPSILON) * 10000) / 10000 }}
                                    </div>
                                </div>
                                <div class="percentage-badge badge-info">
                                    {{
                                        Math.round((totals.cl_50_inhalation_percentage + Number.EPSILON) * 10000) / 10000
                                    }}
                                    %
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <classification v-for="i in 3"
                            v-if="classifications[i - 1]"
                            :key="i"
                            :classification.sync="classifications[i - 1]"
            />
        </div>
        <div v-else>
            <b-card class="mt-2 mb-0"
                    body-class="p-3 text-center"
            >
                <h5 class="text-muted my-4 ">
                    <i class="fa fa-warning"/> No hay componentes para mostrar
                </h5>
            </b-card>
        </div>
    </div>
</template>

<script>

import form_mode from './form_mode.vue';
import summation_method from './summation_method.vue';
import {mapActions, mapState} from 'vuex';
import Classification from '../../../components/classification.vue';

export default {
    name: 'index',
    components: {
        Classification,
        summation_method,
        form_mode
    },
    data() {
        return {
            classifications: [],
            tabs: 0,
            mode: 1,
            name: ''
        };
    },
    async mounted() {
        await this.getMeasureUnitsCl50();
        await this.getClassifications();
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'only_view',
            'totals',
            'grouped_components',
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getClassification',
            'getMeasureUnitsCl50',
            'getGroupedComponents',
            'downloadClassificationAcuteToxicity'
        ]),
        async getClassifications() {
            await this.getGroupedComponents();

            await this.getClassification({product_id: this.product.id, danger_code: 'MCAL19;MCAL20;MCAL21'})
                .then(classifications => this.classifications = classifications);
        }
    }
};
</script>

<style lang="scss"
       src="../../../../../assets/calculator.scss"
/>

<style lang="scss">
.calculator {
    .metric-card {
        background-color: #fdfdfd;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        height: 100%;
        border: 1px solid #d9d9d9;
    }

    .metric-icon {
        width: 45px;
        height: 45px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
    }

    .bg-soft-success {
        background-color: rgba(9, 123, 131, 0.15);
    }

    .status-badge {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0.5px;
        color: #6c757d;
        background-color: #f1f1f1;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .percentage-badge {
        font-size: 12px;
        font-weight: 600;
        padding: 4px 8px;
        border-radius: 4px;
        color: white;
        background-color: #1a94c0;
    }

    .badge-success {
        background-color: #1a94c0;
    }

    .icon-success {
        color: #1a94c0;
    }

    .component-card {
        background-color: white;
        border-radius: 12px;
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
        overflow: hidden;
    }

    .component-header {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    .component-avatar {
        width: 48px;
    }

    .filter-search-form-calc-icon-cancel {
        position: absolute;
        right: 1.4rem;
        top: .45rem;
        color: #9c9c9c;
        font-size: 1.1rem;
    }
}
</style>
